import { useEffect, useState } from 'react';
import axios from 'axios';
import { User, Mail, Phone, Book } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function StudentProfile() {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProfile();
  }, []);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('studentToken');
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${API}/students/profile`, getAuthHeaders());
      setStudent(response.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  if (loading) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm text-center py-12">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-blue border-r-transparent"></div>
        <p className="mt-4 text-slate-600">Loading profile...</p>
      </div>
    );
  }

  if (!student) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm text-center py-12">
        <p className="text-slate-600">Profile not found</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-brand-dark font-display">My Profile</h1>
        <p className="text-slate-600 mt-2">Your account information</p>
      </div>

      <div className="max-w-2xl">
        <div className="space-y-6">
          <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-lg">
            <User className="h-6 w-6 text-brand-blue mt-1" />
            <div className="flex-1">
              <p className="text-sm text-slate-600 mb-1">Full Name</p>
              <p className="text-lg font-semibold text-brand-dark">{student.name}</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-lg">
            <Mail className="h-6 w-6 text-brand-blue mt-1" />
            <div className="flex-1">
              <p className="text-sm text-slate-600 mb-1">Email Address</p>
              <p className="text-lg font-semibold text-brand-dark">{student.email}</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-lg">
            <Phone className="h-6 w-6 text-brand-blue mt-1" />
            <div className="flex-1">
              <p className="text-sm text-slate-600 mb-1">Phone Number</p>
              <p className="text-lg font-semibold text-brand-dark">{student.phone}</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-lg">
            <Book className="h-6 w-6 text-brand-blue mt-1" />
            <div className="flex-1">
              <p className="text-sm text-slate-600 mb-1">Branch</p>
              <p className="text-lg font-semibold text-brand-dark">{student.branch}</p>
            </div>
          </div>

          <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-sm text-slate-600">Member Since</p>
            <p className="text-lg font-semibold text-brand-dark">{formatDate(student.created_at)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
